@if (message().content?.length || message().attachments?.length || showAuthorsImage()) {
  <div
    class="message"
    [class.sent-by-current-user]="isSentByCurrentUser()"
    [class.split-layout]="splitLayout()"
    [class.no-image]="!showAuthorsImage()"
    [class.focus]="hasFocus()"
    [attr.data-message-id]="message().id"
  >
    @if (showAuthorsImage()) {
      <be-user-avatar
        [avatar]="message().sender.image"
        [initials]="message().sender.name | initials"
        [blazeTooltip]="userStatusArray() | userStatusDescription: false : true"
        matTooltipClass="whitespace-pre-line [text-align-last:left]"
        class="self-end"
        [colorInfo]="colorInfo()"
        [status]="userStatusArray()"
      />
    }
    <div
      class="message-body"
      [class.sent-by-current-user]="isSentByCurrentUser()"
      [style.margin-left.px]="showAuthorsImage() ? 0 : 40"
      [class.opacity-60]="message().errorWhileSending"
      [class.show-actions]="showActionsOnHover()"
      [class.message-edited]="messageEditInProgress()"
    >
      @if (showTimeAgo() || showSender()) {
        <div class="message-meta">
          @if (showSender()) {
            <span class="message-sender">
              {{ message().sender.name || message().sender.email }}
              @let userStatusDescription =
                userStatusArray() | userStatusDescription: false : false : true;
              @if (userStatusDescription) {
                <span
                  class="cursor-pointer"
                  [blazeTooltip]="userStatusDescription"
                  matTooltipClass="whitespace-pre-line [text-align-last:left]"
                  matTooltipPosition="above"
                  >💬</span
                >
              }
            </span>
          }
          @if (showTimeAgo()) {
            <span class="message-time">
              @if (modifiedAgo()) {
                Edited • {{ modifiedAgo() }}
              } @else {
                {{ timeAgo() }}
              }
            </span>
          }
        </div>
      }

      @if (showActionsOnHover()) {
        <div class="actions-panel">
          <button
            blazeIconButton
            blazeIconButtonSize="md"
            class="edit-message-button"
            (click)="editMessage.emit()"
          >
            <mat-icon svgIcon="icon_edit_16" />
          </button>
        </div>
      }

      <div class="markdown" [innerHTML]="message().content ?? '' | markdown"></div>
      @if (message().attachments) {
        <div class="attachments" [class.sent-by-current-user]="isSentByCurrentUser()">
          @for (attachment of fileAttachments(); track $index) {
            <div
              class="file-attachment"
              (click)="openAttachmentDialog(attachment)"
              (keydown)="openAttachmentDialog(attachment)"
            >
              <img
                alt=""
                [ngSrc]="attachmentExtensionMap()[attachment].ext"
                width="24"
                height="24"
              />
              <span>{{ attachmentExtensionMap()[attachment].filename }}</span>
            </div>
          }
          @for (attachment of imageAttachments(); track $index) {
            <div class="relative min-w-[90px] min-h-[90px]">
              <img
                class="image-attachment"
                alt=""
                [ngSrc]="attachment"
                fill
                (click)="openAttachmentDialog(attachment)"
                (keydown)="openAttachmentDialog(attachment)"
              />
            </div>
          }
        </div>
      }
    </div>
  </div>
}
@if (message().errorWhileSending) {
  <div class="error-message">
    <mat-icon svgIcon="icon_warning_16" />
    <span>An error occurred while sending the message</span>
  </div>
}
